import Vue from "vue";
import App from "./App.vue";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
import "@/assets/css/reset.scss";
// import VuePreview from "vue-preview";
/**
 * @description 生产环境关掉提示
 */
Vue.config.productionTip = false;
Vue.use(Antd);
new Vue({
  render: (h) => h(App),
  components: {
    App, //在 index.html页面不使用这个组件，就会返回 We're sorry but demo3 doesn't work properly without JavaScript enabled. Please enable it to continue.
  },
}).$mount("#app");
